import React, {Fragment, PureComponent, ReactNode} from 'react'
import {ExclamationCircleIcon} from "@heroicons/react/solid";

type InputProps = {
    id?: string
    type?: string
    name?: string
    placeholder?: string
    value?: string
    className?: string
    required?: boolean
    onChange?: (event: string) => void
    validationMessage?: string
    icon?: any
}

export class Input extends PureComponent<InputProps> {

    onChange = async (event) => {
        this.props.onChange(event.target.value)
    }

    render(): ReactNode {
        return (
            <Fragment>
                <div className="mt-1 relative rounded-md shadow-sm">
                    {this.props.icon && (
                        <div
                            className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            {this.props.icon}
                        </div>
                    )}
                    <input
                        className={`
                        border border-neutral-500
                        rounded
                        shadow
                        ${this.props.validationMessage ? ('border-error-300 text-error-900 placeholder-error-300 focus:outline-none focus:ring-error-500 focus:border-error-500 ') : ''}
                        ${this.props.icon ? 'pl-9' : ''}
                        py-2 px-3 my-2 ${this.props.className ?? ''}`}
                        id={this.props.id}
                        type={this.props.type || 'text'}
                        name={this.props.name}
                        placeholder={this.props.placeholder}
                        required={this.props.required}
                        value={this.props.value}
                        onChange={this.onChange}/>
                    {this.props.validationMessage && (
                        <div
                            className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none">
                            <ExclamationCircleIcon className="h-5 w-5 text-error-500" aria-hidden="true"/>
                        </div>
                    )}
                </div>
                {this.props.validationMessage && (
                    <p className="mt-1 mb-4 text-sm text-error-600" id={`${this.props.id}-error`}>
                        {this.props.validationMessage}
                    </p>
                )}
            </Fragment>
        )
    }
}
